// Navbar.js – Hauptnavigation (react-bootstrap). Die Menüpunkte stehen in LINKS; auf dem Handy klappt das Menü nach einem Klick wieder zu.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Navbar.css";
import Bildmarke from "./pages/images/logo/bildmarke.webp"; // Bäume und Raupe aus dem Logo, ohne Schriftzug

const LINKS = [
  { to: "/baumpflege", label: "Baumpflege" },
  { to: "/mulchen", label: "Landschaftspflege" },
  { to: "/baumfaellung", label: "Baumfällung" },
  { to: "/referenzen", label: "Referenzen" },
  { to: "/ueber-mich", label: "Über mich" },
  { to: "/faq", label: "FAQ" },
];

function Top() {
  // Ausgeklapptes Handy-Menü nach dem Antippen eines Links wieder schließen
  const [expanded, setExpanded] = useState(false);
  const navigiere = () => {
    setExpanded(false);
    window.scrollTo(0, 0);
  };

  return (
    <Navbar expand="lg" className="ff-navbar" sticky="top" expanded={expanded} onToggle={setExpanded}>
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={navigiere}>
          {/* Bildmarke auf heller Fläche (das Logo hat schwarze Teile und braucht hellen Grund), daneben der Schriftzug */}
          <span className="ff-brand__badge">
            <img src={Bildmarke} width={240} height={139} alt="" className="ff-brand__mark" decoding="async" />
          </span>
          {/* Im Text „Forst & Flur“ (Screenreader, Suchmaschinen, wie überall sonst); die Großschreibung kommt aus dem CSS
              (text-transform), die Leerzeichen um das & sind per .visually-hidden aus dem Textfluss genommen, Optik bleibt FORST&FLUR.
              Keine Zeilenumbrüche zwischen den Teilen, sonst entstehen sichtbare Leerzeichen. */}
          <span>Forst<span className="visually-hidden">{" "}</span><span className="brand-amp">&</span><span className="visually-hidden">{" "}</span>Flur</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="ff-main-nav" aria-expanded={expanded} label="Menü" />
        <Navbar.Collapse id="ff-main-nav">
          <Nav className="me-auto">
            {LINKS.map(({ to, label }) => (
              <Nav.Link key={to} as={Link} to={to} onClick={navigiere}>
                {label}
              </Nav.Link>
            ))}
          </Nav>
          {/* Echter Link statt Button: für Suchmaschinen verfolgbar, Öffnen in neuem Tab möglich */}
          <Link
            to="/kontakt"
            className="btn btn-nav-cta ms-2"
            onClick={navigiere}
          >
            Kontakt
          </Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Top;
